import { ProfileV2 } from '../../types';

function hasRoleFoundInCV({ workHistories }: ProfileV2): boolean {
  return workHistories.some((workHistory) => workHistory.foundInCV);
}

export default hasRoleFoundInCV;
